__turbopack_context__.v({
  "content": "ContactModal-module-scss-module__2mRfGq__content",
  "stack-module-0": "ContactModal-module-scss-module__2mRfGq__stack-module-0",
  "stack-module-1": "ContactModal-module-scss-module__2mRfGq__stack-module-1",
  "stack-module-10": "ContactModal-module-scss-module__2mRfGq__stack-module-10",
  "stack-module-11": "ContactModal-module-scss-module__2mRfGq__stack-module-11",
  "stack-module-12": "ContactModal-module-scss-module__2mRfGq__stack-module-12",
  "stack-module-13": "ContactModal-module-scss-module__2mRfGq__stack-module-13",
  "stack-module-14": "ContactModal-module-scss-module__2mRfGq__stack-module-14",
  "stack-module-15": "ContactModal-module-scss-module__2mRfGq__stack-module-15",
  "stack-module-16": "ContactModal-module-scss-module__2mRfGq__stack-module-16",
  "stack-module-17": "ContactModal-module-scss-module__2mRfGq__stack-module-17",
  "stack-module-18": "ContactModal-module-scss-module__2mRfGq__stack-module-18",
  "stack-module-19": "ContactModal-module-scss-module__2mRfGq__stack-module-19",
  "stack-module-2": "ContactModal-module-scss-module__2mRfGq__stack-module-2",
  "stack-module-20": "ContactModal-module-scss-module__2mRfGq__stack-module-20",
  "stack-module-3": "ContactModal-module-scss-module__2mRfGq__stack-module-3",
  "stack-module-4": "ContactModal-module-scss-module__2mRfGq__stack-module-4",
  "stack-module-5": "ContactModal-module-scss-module__2mRfGq__stack-module-5",
  "stack-module-6": "ContactModal-module-scss-module__2mRfGq__stack-module-6",
  "stack-module-7": "ContactModal-module-scss-module__2mRfGq__stack-module-7",
  "stack-module-8": "ContactModal-module-scss-module__2mRfGq__stack-module-8",
  "stack-module-9": "ContactModal-module-scss-module__2mRfGq__stack-module-9",
  "z-base": "ContactModal-module-scss-module__2mRfGq__z-base",
  "z-content": "ContactModal-module-scss-module__2mRfGq__z-content",
  "z-footer": "ContactModal-module-scss-module__2mRfGq__z-footer",
  "z-header": "ContactModal-module-scss-module__2mRfGq__z-header",
  "z-hero": "ContactModal-module-scss-module__2mRfGq__z-hero",
  "z-logo": "ContactModal-module-scss-module__2mRfGq__z-logo",
  "z-logo-effect": "ContactModal-module-scss-module__2mRfGq__z-logo-effect",
  "z-navigation": "ContactModal-module-scss-module__2mRfGq__z-navigation",
  "z-sub": "ContactModal-module-scss-module__2mRfGq__z-sub",
});
